import { Box, Typography } from '@mui/material';
import {
  BenchmarkStatisticsPerMonth,
  MonthlyStatistics,
} from '@tassomutuo-backoffice/types';
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import React from 'react';
import { format, parse } from 'date-fns';
import { it } from 'date-fns/locale';

interface IProps {
  statisticsPerMonth: MonthlyStatistics;
  benchmarkStatisticsPerMonth?: BenchmarkStatisticsPerMonth;
  isPrinting?: boolean;
  reverse?: boolean;
}

const DashboardCrMutuiLeadChart = ({
  statisticsPerMonth,
  benchmarkStatisticsPerMonth,
  isPrinting,
  reverse = true,
}: IProps) => {
  const chartData = Object.entries(statisticsPerMonth).map(([month, stats]) => {
    const crEstimatedMortgagesBench = benchmarkStatisticsPerMonth?.find(
      (m) => m.month === month
    )?.statistics.crEstimatedMortgages;

    return {
      month,
      crEstimatedMortgages: stats.crEstimatedMortgages,
      crEstimatedMortgagesBench: crEstimatedMortgagesBench,
    };
  });

  if (reverse) {
    chartData.reverse();
  }

  return (
    <Box
      sx={{
        backgroundColor: '#FAFAFA',
        padding: 4,
        mt: 6,
        borderRadius: '16px',
        border: '1px solid gainsboro',
      }}
    >
      <Typography variant="h4" mb={1} fontWeight="bold">
        Tasso di Conversione Stimato
      </Typography>
      <Typography variant="h6" mb={4}>
        Rapporto di conversione tra mutui stimati e lead ricevute
      </Typography>
      <Box
        sx={{
          width: '100%',
          height: 400,
          p: 2,
          minWidth: isPrinting ? 1000 : undefined,
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <Line
              type="monotone"
              dataKey="crEstimatedMortgages"
              stroke="rgba(59, 130, 246, 1)"
              strokeWidth={4}
            />
            <Line
              type="monotone"
              dataKey="crEstimatedMortgagesBench"
              strokeWidth={4}
              stroke="rgba(16, 60, 85, 1)"
            />
            <CartesianGrid
              stroke="#ccc"
              strokeDasharray="3 3"
              vertical={false}
            />
            <XAxis
              dataKey="month"
              tickFormatter={(month) => {
                const date = parse(month, 'MMMM yyyy', new Date(), {
                  locale: it,
                });
                return format(date, 'MMM yy', { locale: it });
              }}
            />
            <YAxis domain={[0, (dataMax: number) => Math.ceil(dataMax * 1.1)]} />

            <Tooltip
              //labelFormatter={(label) => `Mese: ${label}`}
              formatter={(value, dataType) => {
                const isBench = dataType === 'crEstimatedMortgagesBench';
                const formattedValue = typeof value === 'number' ? value.toFixed(2) : value;
                return [`${formattedValue}%`, isBench ? 'Benchmark' : 'CR Mutui/Lead'];
              }}
            />
            <Legend
              formatter={(value) => {
                switch (value) {
                  case 'crEstimatedMortgages':
                    return 'CR Mutui/Lead';
                  case 'crEstimatedMortgagesBench':
                    return 'CR Mutui/Lead Benchmark';
                  default:
                    return value;
                }
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default DashboardCrMutuiLeadChart;
